import { msgTypes } from "constants/msgTypes";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { UtilService } from "services/shared/UtilService";
import { BlogModel } from "./BlogModal";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import ApiUrl from "services/shared/ApiUrl";

const Blog = () => {
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [blog, setBlog] = useState(new BlogModel());

  useEffect(() => {
    loadRecentBlog();
  }, []);

  // Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 10;
    return requestBody;
  };

  // Get Blog list
  const loadRecentBlog = async () => {
    const requestBody = prepareRequest();
    const res = await UtilService.getBlogtList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setRecentBlogs(res?.data?.tbody || []);
      setBlog(res?.data?.blogId);
    }
  };

  return (
  <section className="section-blog">
    <div className="container-fluid p-5 pb-0">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="row reveal fade-bottom active">
            {recentBlogs.length > 0 ? (
              recentBlogs.map((blog, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="blog-update">
                    <div className="blog-image">
                      <Link to={`/blog-details/${blog.blogId}`}>
                        <img
                          src={
                            blog.image
                              ? ApiUrl.fileBaseUrl + blog.image
                              : "/images/events/no_images.png"
                          }
                          alt={blog.altTag || "Blog image"}
                        />
                      </Link>
                    </div>
                    <div className="blog-content">
                      <Link to={`/blog-details/${blog.blogId}`}>
                        <h4>{blog.title}</h4>
                      </Link>
                      <p>{blog.shortDescription}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <img
                  src="/images/no-blog.jpg"
                  alt="No blogs available"
                  className="img-fluid"
                  style={{ maxWidth: "300px" }}
                />
                {/* <p className="mt-3">No blogs available at the moment.</p> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
);

};

export default Blog;
